import React, { Component } from "react";
import ReactDOM from "react-dom";
import html2canvas from "html2canvas";
import { withRouter } from "react-router-dom";
import Loading from "../../../../hoc/Loading/Loading";
import axios from "../../../../axios";
import {
  groupContentFields,
  privacyLabel,
  displayEventDates,
  canAddToGroup,
  is_event_past,
  uploadPreview,
  whiteLabelStyling,
  grpBannerImg,
  CANVAS_PROXY_IMAGE_URL,
} from "../../../../utils/constants";
import * as actionCreators from "../../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../../utils/url";
import CommentsSection from "../Sections/CommentsSection/CommentsSection";
import ExportableTool from "./ExportableTool";
import moment from "moment";
import { saveAs } from "file-saver";
import {
  canEditTool,
  canArchiveAndRestoreTool,
  canRemoveShareToolEmails,
} from "../../../../utils/privacySettings";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Label,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Input,
  Alert,
} from "reactstrap";
import calendarIcon from "../../../../assets/calendar_icon.png";
import InviteAttendeesModal from "../../../../components/InviteUser/InviteUsers";
import EventAbout from "../Sections/EventSections/EventAbout";
import EventAttendees from "../Sections/EventSections/EventAttendees";
import EventDiscussion from "../Sections/EventSections/EventDiscussion";
import ShareModal from "./ShareModal";
import ArchiveModal from "./ArchiveModal";
import AddRatingModal from "./AddRatingModal";
import ContactModal from "./ContactModal";
import {
  addToolStep,
  staticTitles,
  calculateTotalRsvp,
} from "../../../../utils/constants";
import favoritedIcon from "../../../../assets/heartFilled.png";
import AddToGroup from "../../../../components/AddToGroup/AddToGroup";
import AddToEvent from "../../../../components/AddToEvent/AddToEvent";
import "../../../../components/UsersEvents/Events.css";
import CalendarAdd from "../../Components/CalendarAdd";
import EventsMap from "../../../../components/AddressSearch/EventsMap";
import ShareEntity from "../../../../components/ShareEntity/ShareEntity";
import { toastContainer } from "../../../../utils/toast";

class EventDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      item: this.props.item,
      attachments: this.props.item.attachments,
      privacy: null,
      description: "",
      memberCount: 1,
      isGroupModal: false,
      bannerImg: null,
      isBannerOpen: false,
      isOpen: false,
      menu: 1,
      isExporting: false,
      dropdownOpen: false,
      isGroupModal: false,
      showContactModal: false,
      showShareModal: false,
      showArchiveModal: false,
      showAddRatingModal: false,
      curr_rsvp: null,
      rsvp_updated: false,
      invited_length: 0,
      interested_length: 0,
      going_length: 0,
    };
  }

  componentDidMount() {
    this.findCurrentRsvpStatus();
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.item) !== JSON.stringify(nextProps.item)) {
      console.log("parent-----update");
      this.setState({
        item: { ...nextProps.item },
      });
    }
  }
  findCurrentRsvpStatus = (status_changed) => {
    let { item, user } = this.props,
      that = this,
      { curr_rsvp } = this.state,
      payload = {
        userId: user.profile._id,
        eventId: item._id,
        organizationId: item.organizationID,
      };
    if (curr_rsvp == null) {
      axios
        .post(url.getSingleUserEvent, payload)
        .then(({ data }) => {
          let resp = data.data;
          that.setState({
            curr_rsvp: resp && resp.hasOwnProperty("rsvp") ? resp.rsvp : -1,
            rsvp_updated: false,
            item: this.props.item,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (status_changed && status_changed.isUpdated) {
      that.setState({
        curr_rsvp: status_changed.rsvp,
        item: this.props.item,
      });
    }
  };

  createMarkup = (input) => {
    return { __html: `<div>${input}</div>` };
  };

  renderContent = () => {
    let { searchedPhrase, help, searchedTerm } = this.state;
    if (searchedTerm !== "") {
      return (
        <div dangerouslySetInnerHTML={this.createMarkup(searchedPhrase)} />
      );
    } else {
      return <div dangerouslySetInnerHTML={this.createMarkup(help)} />;
    }
  };

  changeGroupName = (name) => {
    this.setState({ name });
  };

  changePrivacy = (privacy) => {
    if (privacy) {
      this.setState({ privacy });
    }
  };

  handleInvitedUsers = (mLength) => {
    this.setState({ memberCount: mLength + 1 });
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  changeGrpBannerImg = (query) => {
    // headers: {
    //   'Authorization': `Basic ${token}`
    // }
  };

  openBannerModal = () => {
    this.setState((prevState) => ({
      isBannerOpen: !prevState.isBannerOpen,
    }));
  };

  handleExportClick = () => {
    let { toolDetails } = this.state;
    this.setState(
      {
        isExporting: true,
      },
      () => {
        // ReactDOM.findDOMNode(this.toolDetailRef).style.display="block";
        let node = ReactDOM.findDOMNode(this.toolDetailRef);
        this.setState({ isExporting: false });

        html2canvas(node, {
          useCORS: true,
          allowTaint: true,
          proxy: CANVAS_PROXY_IMAGE_URL,
        }).then((canvas) => {
          canvas.toBlob((blob) => {
            let newWindow = window.open("/");
            newWindow.location = URL.createObjectURL(blob);
            let name =
              toolDetails && toolDetails.name
                ? `${toolDetails.name}.png`
                : "tooldetail.png";
            saveAs(blob, name);
          });
        });
      }
    );
  };

  handleShowShareModal = () => {
    const { toolDetails } = this.state;
    let { orgUserList } = this.state;
    if (orgUserList && orgUserList.length > 0) {
      this.toggleShareModal();
    } else {
      this.getOrgUserList();
    }
  };

  closeInviteModal = (invited_length) => {
    let res = { isOpen: false };
    if (invited_length && parseInt(invited_length) > 0) {
      let { item } = this.state;
      let updated_item = {
        ...item,
        invitee_count: this.state.item.invitee_count + invited_length,
      };

      res = {
        ...res,
        item: updated_item,
      };
    }

    this.setState(res);
  };

  openInviteModal = () => {
    this.setState({ isOpen: true });
  };

  renderUploadPreview = (source) => {
    return source.map((photo, idx) => {
      let { size, url } = photo;
      let img = uploadPreview(photo);
      let { preview, isMsIcon } = img;
      let mb = 1024 * 1024;
      let file_size =
        size >= mb
          ? `${(size / mb).toFixed(2)}mb`
          : `${(size / 1024).toFixed(2)}kb`;
      return (
        <span
          key={idx}
          className={
            photo.isAccepted == false
              ? "taskUploadPreviewImg rejectedFilesContainer"
              : "taskUploadPreviewImg"
          }
        >
          <img src={preview} className="fileUploadSize" />
          <span
            key={preview + idx}
            onClick={() => this.removeImage(photo)}
            className="removeTaskUpload"
          >
            <span className="flaticon-trash" />
          </span>
          <div className="previewTaskImageText">
            <span className="previewTaskImageTitle">{photo.name}</span>
            <span className="previewTaskImageTitle">{file_size}</span>
            <span className="taskAttachmentContent">
              <a href={url} target="_blank">
                Download
              </a>{" "}
              ({file_size})
            </span>
          </div>
        </span>
      );
    });
  };

  toggleTaskView = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  selectMenu = (menu) => {
    this.setState({ menu });
  };

  handleRemoveToFavorite = () => {
    axios
      .put(url.removeFromFavorites, { ids: [this.state.item._id] })
      .then((response) => {
        this.setState({ item: { ...this.state.item, isFavorite: false } });
      })
      .catch((error) => {});
  };

  handleAddToFavorite = () => {
    axios
      .post(url.addToFavorites, { ids: [this.state.item._id] })
      .then((response) => {
        this.setState({ item: { ...this.state.item, isFavorite: true } });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  addGroupModal = () => {
    let { isGroupModal } = this.state;
    this.setState({ isGroupModal: !isGroupModal });
  };

  handleArchiveTool = () => {
    const { item } = this.state;
    let user = this.props.user.profile;
    let userRole =
      user && user.orgAdmin
        ? "ADMIN"
        : user._id == item.createdBy._id
        ? "OWNER"
        : false;

    axios
      .put(url.archiveTools, { list: [this.state.item._id], userRole })
      .then((response) => {
        let val = { ...this.state.item };
        val.isArchive.value = true;
        this.setState({ val, showArchiveModal: false });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  toggleContactModal = () => {
    this.setState((prev) => ({ showContactModal: !prev.showContactModal }));
  };

  toggleShareModal = () => {
    this.setState((prev) => ({ showShareModal: !prev.showShareModal }));
  };

  toggleArchiveModal = () => {
    this.setState((prev) => ({ showArchiveModal: !prev.showArchiveModal }));
  };

  toggleRatingModal = () => {
    this.setState((prev) => ({ showAddRatingModal: !prev.showAddRatingModal }));
  };

  handleAddOrRemoveFavorite = () => {
    if (this.state.item.isFavorite) {
      this.handleRemoveToFavorite();
    } else {
      this.handleAddToFavorite();
    }
  };

  handleEditTool = () => {
    const { isGroupEvent } = this.props;
    let editToolDetails = { ...this.state.item };
    const category =
      this.props.match.params.category || this.props.popupPropCat;
    editToolDetails.nextStep = addToolStep.info;
    this.props.onToolEditLoaded({
      ...editToolDetails,
      redirectionPath: isGroupEvent
        ? `/home/toolkit/${this.props.match.params.groupId}/${category}/edit/${editToolDetails._id}`
        : `/home/toolkit/${category}/edit/${editToolDetails._id}`,
    });
    // if(!editToolDetails.isArchive.value) {
    //   editToolDetails.nextStep = addToolStep.info;
    //   this.props.onToolEditLoaded({...editToolDetails, redirectionPath: `/home/toolkit/${category}/edit/${editToolDetails._id}`});
    // } else {
    //   this.setState({showWarningModal: true, warningModalAction: 'edit'});
    // }
  };

  handleRestoreArchivedTool = () => {
    axios
      .put(url.restoreTool, { list: [this.state.item._id] })
      .then((response) => {
        // this.setState({toolDetails: {...this.state.toolDetails, "isArchive.value": false }} );
        let val = { ...this.state.item };
        val.isArchive.value = false;
        this.setState({ item: val });
      })
      .catch((error) => {});
  };

  addToGroup = () => {
    this.setState({ isGroupModal: true });
  };

  closeGroupModal = () => {
    this.setState({ isGroupModal: false });
  };

  renderDropDownViews = () => {
    const canArchiveAndRestore = canArchiveAndRestoreTool(
      this.state.item,
      this.props.user.profile
    );
    let { isFavorite, isArchive } = this.state.item,
      { item } = this.state;

    // #162337

    return (
      <Dropdown
        isOpen={this.state.dropdownOpen}
        toggle={this.toggleTaskView}
        className="event_details_action_dropdown_btn event_details_btn_group"
      >
        <DropdownToggle caret>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
            className=""
          >
            <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
            <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
          </svg>
        </DropdownToggle>
        <DropdownMenu className="singleTaskViewMenu">
          {/* <DropdownItem header>Select a view</DropdownItem> */}
          <DropdownItem
            className="chartBtnView"
            onClick={() => this.handleAddOrRemoveFavorite()}
          >
            {isFavorite ? (
              <img style={{ height: "20px" }} src={favoritedIcon} />
            ) : (
              <span
                style={{ color: "#5099DE" }}
                className="flaticon-heart"
              ></span>
            )}
            {isFavorite ? "Remove from favorites" : "Add to favorites"}
          </DropdownItem>

          {canAddToGroup(this.state.item, this.props.user) &&
          item.groupId == null ? (
            <DropdownItem
              className="chartBtnView"
              onClick={() => this.addToGroup()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#223e6d"
                className=""
                viewBox="0 0 16 16"
              >
                <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"></path>
              </svg>
              Add to Group{" "}
            </DropdownItem>
          ) : null}

          {/* <DropdownItem className="chartBtnView" onClick={()=>this.toggleRatingModal()}> Rate </DropdownItem> */}

          <DropdownItem
            className="chartBtnView"
            onClick={() => this.handleExportClick()}
          >
            <span style={{ color: "#5099DE" }} className="flaticon-export" />
            Export{" "}
          </DropdownItem>
          <DropdownItem
            className="chartBtnView"
            onClick={() => this.toggleContactModal()}
          >
            <span style={{ color: "#5099DE" }} className="flaticon-mail" />
            Contact Info{" "}
          </DropdownItem>

          {/* <DropdownItem divider /> */}
          {canArchiveAndRestore ? (
            <DropdownItem
              className="toolkitBtnView"
              onClick={
                isArchive && isArchive.value
                  ? () => this.handleRestoreArchivedTool()
                  : () => this.toggleArchiveModal()
              }
            >
              <span style={{ color: "#5099DE" }} className="flaticon-trash" />
              {isArchive && isArchive.value ? "Restore" : "Archive"}{" "}
            </DropdownItem>
          ) : null}
        </DropdownMenu>
      </Dropdown>
    );
  };

  changeEventStatus = (result) => {
    let { updated_event, event_rsvps } = result;
    let { item } = this.state;
    let {
      rsvp_count,
      invitee_count,
      interested_count,
      going_count,
    } = updated_event;
    let res = {
      ...item,
      rsvp_count,
      invitee_count,
      interested_count,
      going_count,
    };
    this.setState({ item: res, rsvp_updated: true });
    event_rsvps = { ...event_rsvps, isUpdated: true };
    // this.findCurrentRsvpStatus(event_rsvps)
  };

  updated_user_rsvp_status = (result) => {
    let { updated_event, event_rsvps } = result;
    let { item, interested_length, going_length } = this.state;
    let res;
    let update_obj;

    if (updated_event) {
      let {
        rsvp_count,
        invitee_count,
        interested_count,
        going_count,
      } = updated_event;
      res = {
        ...item,
        rsvp_count,
        invitee_count,
        interested_count,
        going_count,
      };
      update_obj = { item: res };
    }

    if (event_rsvps) {
      update_obj = { ...update_obj, curr_rsvp: event_rsvps.rsvp };
      let { rsvp } = event_rsvps;
      if (rsvp.value == 1) {
        update_obj = {
          ...update_obj,
          // interested_length: interested_length+1
        };
      } else if (rsvp.value == 2) {
        update_obj = {
          ...update_obj,
          // going_length: going_length+1
        };
      }
    }

    this.setState(update_obj);
  };

  check_if_usr_member = (tool, current_user, invited_event_status) => {
    let { curr_rsvp } = this.state;
    return (
      (current_user && tool && current_user._id == tool.createdBy._id) ||
      (curr_rsvp &&
        typeof curr_rsvp == "object" &&
        invited_event_status &&
        curr_rsvp.value > 0) ||
      (tool.invitedUsers &&
        tool.invitedUsers.length > 0 &&
        tool.invitedUsers.filter((e) => e.value == current_user._id).length >
          0) ||
      (tool.groupId &&
        current_user.groups &&
        current_user.groups.length > 0 &&
        current_user.groups.filter(
          (e) => e.o_id.toString() == tool.groupId.toString()
        ).length > 0)
    );
  };

  is_event_past = () => {
    let { item } = this.state;
    if (item) {
      let endDate = moment(item.endDate);
      if (endDate.isAfter(moment())) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  };

  event_not_archived = () => {
    let { item } = this.state;
    if (item) {
      let { isArchive } = item;
      if (isArchive && isArchive.value == true) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  };

  renderRsvpContent = () => {
    let { curr_rsvp, item } = this.state,
      { eventuser } = this.state.item;

    let endDate = moment(item.endDate);

    if (this.event_not_archived()) {
      if (is_event_past(item)) {
        if (this.state.item.groupId) {
          if (
            this.check_if_usr_member(this.state.item, this.props.user.profile)
          ) {
            return (
              <AddToEvent
                isEventDetails={true}
                findCurrentRsvpStatus={this.findCurrentRsvpStatus}
                curr_rsvp={curr_rsvp}
                from_module="Toolkit"
                isParentType={3}
                item={
                  eventuser && Object.keys(eventuser).length > 0
                    ? eventuser
                    : item
                }
                updated_user_rsvp_status={this.updated_user_rsvp_status}
              />
            );
          }
          return <span></span>;
        } else {
          return (
            <AddToEvent
              isParentType={3}
              isEventDetails={true}
              from_module="Toolkit"
              findCurrentRsvpStatus={this.findCurrentRsvpStatus}
              curr_rsvp={curr_rsvp}
              item={
                eventuser && Object.keys(eventuser).length > 0
                  ? eventuser
                  : item
              }
              updated_user_rsvp_status={this.updated_user_rsvp_status}
            />
          );
        }
      } else {
        return (
          <span className="event_details_page_btn single_event_details_rsvp_closed event_details_btn_group">
            Event ended
          </span>
        );
      }
    } else {
      return (
        <span className="event_details_page_btn single_event_details_rsvp_closed event_details_btn_group">
          Event has been archived
        </span>
      );
    }
  };

  check_edit_rights = () => {
    let { item } = this.state;
    let edit_rights =
      item.invitedUsers && item.invitedUsers.length > 0
        ? item.invitedUsers.filter(
            (e) => e.value == this.props.user.profile._id
          )
        : [];

    console.log(item.privacy, item.permission);
    if (edit_rights.length > 0) {
      if (edit_rights[0].permissions == 1) return true;
    } else if (this.props.user.profile.orgAdmin) {
      return true;
    } else if (item.privacy === "ENTERPRISE" && item.permission === "EDIT") {
      return true;
    }
    return false;
  };

  updateEventRsvp = (updated_tool) => {
    let {
      rsvp_count,
      invitee_count,
      interested_count,
      going_count,
    } = updated_tool;
    let res = {
      ...this.state.item,
      rsvp_count,
      invitee_count,
      interested_count,
      going_count,
    };

    this.setState({ item: res });
  };

  sendEventReminders = () => {
    axios
      .post(url.sendEventReminds, {
        eventId: this.state.item._id,
      })
      .then(({ data }) => {
        toastContainer("Reminders sent successfully", "success");
      })
      .catch((err) => {
        toastContainer("Error while sending reminders", "error");
      });
  };

  render() {
    let {
      item,
      menu,
      isExporting,
      showContactModal,
      showArchiveModal,
      invited_length,
      going_length,
      interested_length,
      isGroupModal,
      curr_rsvp,
      isOpen,
    } = this.state;

    let {
      name,
      privacy,
      description,
      category,
      createdBy,
      startDate,
      bannerImg,
      isRecommendedByAdmin,
      image,
      eventuser,
    } = this.state.item;

    let bg_image =
      bannerImg != null && bannerImg.url
        ? bannerImg.url
        : image && image != null
        ? image
        : grpBannerImg;
    console.log("cat----", category);
    return (
      <span className="">
        <div className="grp_event_details_page_container boxShadow1">
          <div className="grp_event_detail_bannerImg_container cursor-default">
            <div
              className="event_details_bg_image_blur"
              style={{ backgroundImage: `url(${bg_image})` }}
            />
            <img
              src={bg_image}
              className={`grp_create_page_bannerImg cursor-default ${
                bannerImg == null && image == null
                  ? "banner_filter"
                  : "boxShadow1"
              }`}
            />
          </div>

          <div
            style={{
              paddingBottom:
                category == "Diversity Calendar" ? "0px" : "inherit",
            }}
            className="grp_create_page_details"
          >
            <span>
              <span className="event_page_calendar_date_range_container">
                <img
                  src={calendarIcon}
                  className="event_page_calendar_date_range_icon"
                />
                {startDate ? (
                  <span className="event_page_calendar_date_day_input">
                    {moment(startDate).format("D")}
                  </span>
                ) : null}
              </span>
              <span className="event_page_calendar_date_range">
                {displayEventDates(item, true)}
              </span>

              {/* <span>
                    <AddRatingModal
                      showModal={showAddRatingModal}
                      toggle={this.toggleRatingModal}
                      toolDetails={toolDetails}
                      onRateTool={this.handleRateTool}
                    />
                  </span> */}
            </span>

            <span
              style={{
                marginBottom:
                  category == "Diversity Calendar" ? "2px" : "inherit",
              }}
              className={`grp_create_page_group_name ${
                name != "" ? "active" : ""
              }`}
            >
              {name != "" ? name : "Event"}
            </span>

            {isRecommendedByAdmin != true ? (
              <span className="grp_create_page_group_status_count">
                {privacy != null ? (
                  <span className="grp_create_page_group_status">
                    {privacyLabel[privacy]}
                  </span>
                ) : null}

                {category != "Diversity Calendar" ? (
                  <span>
                    <span className="grp_md_dt_01">·</span>
                    <span className="grp_create_page_member_count">
                      {calculateTotalRsvp(item, "rsvp")} rsvps
                    </span>
                  </span>
                ) : null}
              </span>
            ) : null}

            {/* <div className="grp_create_page_group_status"> </div> */}

            <div className="event_details_page_button_group">
              {this.renderDropDownViews()}

              {category != "Diversity Calendar" ? (
                is_event_past(item) &&
                this.event_not_archived(item) &&
                (privacy != "PRIVATE" ||
                  (privacy == "PRIVATE" &&
                    this.check_if_usr_member(
                      this.state.item,
                      this.props.user.profile,
                      true
                    ))) ? (
                  <div
                    className="event_details_page_btn attendees_btn event_details_btn_group"
                    onClick={() => this.openInviteModal()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
                    </svg>
                    Invite
                  </div>
                ) : null
              ) : null}

              {category != "Diversity Calendar" ? (
                createdBy._id == this.props.user.profile._id ||
                this.check_edit_rights() ? (
                  <div
                    className="event_details_page_btn edit_event_btn event_details_btn_group"
                    onClick={() => this.handleEditTool()}
                  >
                    Edit
                    <span
                      style={{ color: "#5099DE" }}
                      className="flaticon-edit"
                    />
                  </div>
                ) : null
              ) : null}

              {category == "Conferences & Events" ? (
                this.state.item.hasOwnProperty("groupId") ? (
                  this.check_if_usr_member(
                    this.state.item,
                    this.props.user.profile
                  ) ? (
                    this.renderRsvpContent()
                  ) : (
                    <Alert
                      color="warning"
                      // className="col-lg-12 col-md-12"
                    >
                      <span className="alert-info-text">
                        <span className="alert-info-icon"></span>
                        <span>Please Contact Host to RSVP</span>
                      </span>
                    </Alert>
                  )
                ) : (
                  this.renderRsvpContent()
                )
              ) : null}
            </div>
          </div>

          <div
            className="grp_create_page_details_2"
            style={{ display: "flex" }}
          >
            <span
              onClick={() => this.selectMenu(1)}
              style={whiteLabelStyling(
                ["textDecorationColor"],
                this.props.user.profile.organizationId,
                menu != 1
              )}
              className={`grp_page_menu_items ${
                menu == 1 ? "grp_menu_item_selected" : ""
              }`}
            >
              About
            </span>
            {/* <span 
             onClick={()=>this.selectMenu(2)} 
            style={whiteLabelStyling(['textDecorationColor'], this.props.user.profile.organizationId, menu!=2)}
            className={`grp_page_menu_items ${ menu==2?'grp_menu_item_selected':''}`}>Comments</span> */}

            <div
              className="d-flex ml-auto"
              style={{ justifyContent: "flex-end" }}
            >
              <Button
                className="ml-auto mr-3"
                style={{ borderRadius: "8px" }}
                size="sm"
                color="primary"
                outline
                onClick={() => {
                  this.sendEventReminders();
                }}
              >
                Send Reminders
              </Button>
              {item && item._id ? (
                <ShareEntity
                  user={this.props.user}
                  entityType="RESOURCES"
                  display="POPPER"
                  item={{ ...item }}
                  customClass="event_share_wrapper"
                />
              ) : (
                ""
              )}

              {is_event_past(item) && this.event_not_archived(item) ? (
                <CalendarAdd description={description} item={item} />
              ) : null}
            </div>
          </div>

          <div className="">
            {menu == 1 ? (
              <EventAbout
                invited_length={invited_length}
                updateEventRsvp={this.updateEventRsvp}
                interested_length={interested_length}
                going_length={going_length}
                curr_rsvp={curr_rsvp}
                item={item}
                user={this.props.user.profile}
                updateAttachments={this.props.updateAttachments}
              />
            ) : menu == 2 ? (
              <EventDiscussion curr_rsvp={curr_rsvp} item={item} menu={menu} />
            ) : menu == 3 ? (
              <EventAttendees curr_rsvp={curr_rsvp} item={item} />
            ) : null}
          </div>

          {/* <EventsMap item={item} /> */}
        </div>

        {isOpen ? (
          <InviteAttendeesModal
            eventId={item._id}
            closeInviteModal={this.closeInviteModal}
            isOpen={isOpen}
            disableUsersModel={"eventusers"}
            item={item}
          />
        ) : null}

        {isGroupModal ? (
          <AddToGroup
            closeGroupModal={this.closeGroupModal}
            modelName={"OfficeToolkit"}
            itemType={item.category}
            itemId={item._id}
            item={item}
            isOpen={isGroupModal}
          />
        ) : null}

        <ContactModal
          showModal={showContactModal}
          toggle={this.toggleContactModal}
          toolDetails={item}
        />
        {/* <ShareModal
               showModal={showShareModal}
               toggle={this.toggleShareModal}
               onShareTool={this.handleShareTool}
               orgUserList={orgUserList}
               toolDetails={item}
               currentUser={this.props.user.profile._id}
               allowRemoveShareToolEmails={allowRemoveShareToolEmails}
             /> */}

        {showArchiveModal ? (
          <ArchiveModal
            showModal={showArchiveModal}
            toggle={this.toggleArchiveModal}
            toolDetails={item}
            currentUser={this.props.user.profile}
            archiveTool={this.handleArchiveTool}
          />
        ) : null}

        {isExporting ? (
          <div
            className="exportToolcontainer"
            style={{
              display: "block",
              position: "absolute",
              top: "10000px",
              zIndex: "-99999999",
            }}
            ref={(r) => (this.toolDetailRef = r)}
          >
            <ExportableTool
              isExporting={true}
              // ref={(r) => this.toolDetailRef = r}
              toolDetails={this.state.item}
              user={this.props.user}
            />
          </div>
        ) : null}
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToolEditLoaded: (data) => dispatch(actionCreators.editToolLoaded(data)),
    onToolInfoCompleted: (data) =>
      dispatch(actionCreators.toolInfoCompleted(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(EventDetail, axios)));
